import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OnboardingStore {
  onboardingInfoSheetClosed: boolean;
  setOnboardingInfoSheetClosed: (onboardingInfoSheetClosed: boolean) => void;
}

export const useOnboardingStore = create<OnboardingStore>()(
  persist(
    (set) => ({
      onboardingInfoSheetClosed: false,
      setOnboardingInfoSheetClosed: (onboardingInfoSheetClosed: boolean) => {
        set({ onboardingInfoSheetClosed });
      },
    }),
    {
      name: 'onboarding-store',
    },
  ),
);
